import { Outlet } from "react-router-dom";
import Header, { WhatsAppFloat } from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-bone">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" richColors />
    </div>
  );
}
